import { Checkmark, FontAwesomeIcon, InProgressCheck, LoadingBars, TagIcon } from './template';
export { Checkmark, FontAwesomeIcon, InProgressCheck, LoadingBars, TagIcon };
